// WorkLogTimerWidget.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stopWorkLog, setWorkLogWidgetOpen } from "../../actions/workLogActions";

const fmt2 = (n) => String(n).padStart(2, "0");

const WorkLogTimerWidget = () => {
    const dispatch = useDispatch();
    const { running } = useSelector((s) => s.workLog);
    const [tick, setTick] = useState(0);

    useEffect(() => {
        const t = setInterval(() => setTick((x) => x + 1), 1000);
        return () => clearInterval(t);
    }, []);

    const elapsed = useMemo(() => {
        if (!running?.startedAt) return "00:00:00";
        const start = new Date(running.startedAt).getTime();
        const now = Date.now();
        const diff = Math.max(0, now - start);
        const totalSec = Math.floor(diff / 1000);
        const h = Math.floor(totalSec / 3600);
        const m = Math.floor((totalSec % 3600) / 60);
        const s = totalSec % 60;
        return `${fmt2(h)}:${fmt2(m)}:${fmt2(s)}`;
    }, [running, tick]);

    const popout = () => {
        const w = 360;
        const h = 220;
        const left = Math.max(20, window.screenX + window.outerWidth - w - 20);
        const top = Math.max(20, window.screenY + 60);
        const url = `${window.location.origin}${window.location.pathname}?timer=1`;
        window.open(url, "WorkLogTimer", `width=${w},height=${h},left=${left},top=${top}`);
    };

    if (!running) {
        return (
            <div className="work-log-widget">
                <div className="work-log-widget__title">Таймер</div>
                <div className="work-log-widget__empty">Нет активной задачи</div>
                <div className="work-log-widget__actions">
                    <button className="work-log__btn is-secondary" type="button" onClick={() => dispatch(setWorkLogWidgetOpen(false))}>Скрыть</button>
                </div>
            </div>
        );
    }

    return (
        <div className="work-log-widget">
            <div className="work-log-widget__title">В работе</div>
            <div className="work-log-widget__task">{running.title}</div>
            <div className="work-log-widget__time">{elapsed}</div>

            <div className="work-log-widget__actions">
                <button className="work-log__btn" type="button" onClick={() => dispatch(stopWorkLog(running._id))}>Stop</button>
                <button className="work-log__btn is-secondary" type="button" onClick={popout}>Popout</button>
                <button className="work-log__btn is-secondary" type="button" onClick={() => dispatch(setWorkLogWidgetOpen(false))}>Скрыть</button>
            </div>
        </div>
    );
};

export default WorkLogTimerWidget;
